export function getElement(id) {
   return document.getElementById(id);
}

export function checkAndAddCssClass(element, className) {
   if (element) {
      
      if (!element.classList.contains(className)) {
         element.classList.add(className);
      }
   }
}

export function checkAndAddCssClassToRefContainerChildren({
   refContainer,
   selector,
   className = 'fade-in',
   intervalDuration = 30,
}) {
   
   let classParts = className.split(' ');
   
   classParts = classParts?.map(part => {
      return typeof part === 'string' ? part.trim() : '';
   }).filter(part => part.length > 0);
   
   
   let intervalId = null;
   
   intervalId = setInterval(() => {
      
      if (refContainer.current && (refContainer.current instanceof HTMLElement)) {
         
         let selectedElement = refContainer.current.querySelector(selector);
         
         if (selectedElement && !selectedElement.classList.contains(className)) {
            selectedElement.classList.add(...classParts);
            clearInterval(intervalId);
         }
      }
      
   }, intervalDuration);
   
}